export function calculatePreviousStartDate(startDate, endDate) {
  let startDateObj = new Date(startDate);
  let endDateObj = new Date(endDate);

  const diffTime = Math.ceil((Math.abs(endDateObj - startDateObj)) / (1000 * 60 * 60 * 24));

  let prevStartDateObj = new Date(startDateObj);
  prevStartDateObj.setDate(prevStartDateObj.getDate() - diffTime);

  const prevStartDate = prevStartDateObj.toISOString().split('T')[0];

  return prevStartDate;
}

export function getPointsFromHeatmap(responseData) {
  const arr = [];
  let i = 0;
  do {
    const data = responseData[i].points;
    arr.push(...data);
    i++;
  } while (i < responseData.length);
  return arr;
}

export const convertHeatmapObjToArray = (obj) => {
  return Object.keys(obj).map(key => {
    const value = obj[key];           // Değeri alıyoruz (3000 gibi)

    // Anahtarı x ve y değerlerine parçala
    const x = parseInt(key.match(/x(\d+)/)[1], 10);  // '100' kısmını al
    const y = parseInt(key.match(/y(\d+)/)[1], 10);  // '300' kısmını al

    // Dönüştürülmüş nesneyi döndür
    return { x, y, value };
  });
};

export async function createLinkForDynamicTextFont(fontList) {
  try {
    let fonts = '';
    let i = 0;
    do {
      if (fontList[i].isGoogleFonts === true) {
        const googleFontLink = createGoogleFontLink(fontList[i]);
        fonts += googleFontLink.outerHTML;
      } else if (fontList[i].isGoogleFonts === false) {
        const brandFontLink = createBrandFontLink(fontList[i]);
        fonts += brandFontLink.outerHTML;
      }
      i++;
    } while (i < fontList.length);
    return fonts;
  } catch (error) {
    // console.log(error);
  }
}

export function getFontNamesFromDynamicText(dynamicText = []) {
  try {
    const fontFamilies = new Set();
    let i = 0;
    do {
      let l = 0;
      do {
        const text = dynamicText[i].texts[l];
        if (text.type === 'text') {
          if (text.isFeed === false) {
            const parser = new DOMParser();
            const doc = parser.parseFromString(text.value, 'text/html');
            const elements = doc.querySelectorAll('*[style]');
            elements.forEach(item => {
              const style = item.getAttribute('style');
              const match = style.match(/font-family:\s*([^;]+)/);
              if (match) {
                fontFamilies.add(match[1].replace(/['"]/g, '').trim());
              } else {
                fontFamilies.add('Poppins');
              }
            });
          } else {
            if (text?.style) {
              const match = text?.style.match(/font-family:\s*([^;]+)/);
              if (match) {
                fontFamilies.add(match[1].replace(/['"]/g, '').trim());
              }
            } else {
              fontFamilies.add('Poppins');
            }
          }
        }
        l++;
      } while (l < dynamicText[i].texts.length);
      i++;
    } while (i < dynamicText.length);
    const fontNames = Array.from(fontFamilies);
    return fontNames;
  } catch (error) {
    // console.log(error);
    return [];
  }
}

export function createGoogleFontLink(font) {
  let fontLink;
  if (document.querySelector(`link[font-name="${font?.family}"]`)) {
    fontLink = document.querySelector(`link[font-name="${font?.family}"]`);
  } else {
    if (font.hasOwnProperty('preview')) {
      fontLink = document.createElement("link");
      fontLink.rel = "stylesheet";
      fontLink.href = font.preview.replace(/&text=[^&]*/, '');
      fontLink.setAttribute('font-name', font.family);
      document.head.appendChild(fontLink);
    }
  }
  return fontLink;
}

export function createBrandFontLink(font) {
  const fontCss = `@font-face {font-family: ${font.family}; font-style: ${font.style}; font-weight: ${font.weight}; font-display: swap; src: url("${font.src}") format("${font.format}")}`
  const style = document.createElement("style");
  style.innerHTML = fontCss;
  document.head.appendChild(style);
  return style;
}

export function getTodayAndPastWeek() {
  let endDate = new Date();
  let startDate = new Date();
  startDate.setDate(endDate.getDate() - 7);
  return [startDate, endDate];
}

export function reduceSocialCampaigns(campaigns) {
  return campaigns.filter(campaign => campaign.adType !== 'social');
}